// extracted by mini-css-extract-plugin
module.exports = {"faqWrapper":"_24oyf","allFaqWrapper":"_1fGvn","faqMainWrapper":"_1IZlk","allfqa":"_2ZRv7"};